module.exports = __webpack_public_path__ + "static/bottom_circles-005919e4e5b61d4ac8cce1e4456412b2.png";